module.exports = __webpack_public_path__ + "img/vip_badge_4.c7e50096.png";